import { render, staticRenderFns } from "./home-more.vue?vue&type=template&id=36f470e6"
import script from "./home-more.vue?vue&type=script&lang=js"
export * from "./home-more.vue?vue&type=script&lang=js"
import style0 from "./home-more.vue?vue&type=style&index=0&id=36f470e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports